import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  pdfUrl = 'assets/pdf/vaishcollege-applicationform.pdf';
  onlineFormUrl = 'https://data.odpay.in/odforms1/form/VaishCollegeApplicationFormForPostPrincipal/formperma/hxyznmbw7xYD4sVaKwzV0e_CK-CHAsBQ2fehWY-0loU?zf_enablecamera=true';
  formsRoute = '/apply-online';

  isLightboxOpen = false;
  selectedImageSrc = '';

  newsImages = [
    // { src: 'assets/img/news/news-2.jpg', title: 'Employment Notice: Lady Principal', desc: 'Notice published in newspapers for recruitment of Lady Principal.' },
    // { src: 'assets/img/news/news-3.jpg', title: 'Guidelines & Qualifications', desc: 'Notice detailing UGC/KUK qualifications and pay scale rules.' },
    // { src: 'assets/img/news/news-4.jpg', title: 'Principal Vacancy News Advertisement', desc: 'Notice outlining eligibility and submission details.' },
    // { src: 'assets/img/news/news-5.jpg', title: 'Faculty Recruitment Guidelines', desc: 'Instructions regarding regular teaching and non-teaching posts.' }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  openLightbox(src: string): void {
    this.selectedImageSrc = src;
    this.isLightboxOpen = true;
  }

  closeLightbox(): void {
    this.isLightboxOpen = false;
    this.selectedImageSrc = '';
  }

}
